module.exports = __webpack_public_path__ + "static/media/nc1.15cab454.png";